import React from "react";
import "../screens/registration.css";
import {Form} from 'react-bootstrap'

let BootstrapDropdown = (props) => {
  const { labelName, propsArr, onChange,disabled } = props;
  return (
    <>
      <Form.Label style={{ fontWeight: "bold", color: "#585962" }} for="inputState">
        {labelName}
      </Form.Label>
      {/* <span style={{ paddingLeft: 2, color: "red" }} class="required">
        *
      </span> */}
      <Form.Control as="select"  onChange={onChange} disabled={disabled}>
        <option>Select Option</option>
        {propsArr.length != 0
          ? propsArr
              .filter((val) => {
                return val != null;
              })
              .map((e, i) => {
                return (
                  <option key={i} value={e}>
                    {e}
                  </option>
                );
              })
          : null}
      </Form.Control>
    </>
  );
};
export default BootstrapDropdown;
